"use strict";

var get = require('../getValueOfKeyMatching');

function SeatingCharts(params) {
  var quantity = 1;
  var product_size = get(params, /charts_size/).replace('"', '');
  this.ink_colors = ['Black'];
  this.personalization.push({
    name: 'Wording',
    value: get(params, /wording/)
  });
  this.personalization.push({
    name: 'Chart Arrangement',
    value: get(params, /arrangement/)
  });
  this.seatingCharts.add({
    quantity: quantity,
    product_size: product_size
  });
}

module.exports = SeatingCharts;